module.exports = __webpack_public_path__ + "img/device_1011_3_select.1e874183.svg";